import { useTranslation } from "react-i18next";
import { InstituteFilterSelect } from "@/features/tenantUsers/components/InstituteFilterSelect";
import { useInstitutionOptions } from "../hooks/useInstitutionOptions";

interface TeacherInstituteFilterProps {
  /** Selected institute id, "" for all institutes. */
  value: string;
  onChange: (instituteId: string) => void;
}

/**
 * Searchable institute dropdown shown next to the teachers search box. Options come from
 * GET api/v1/institutions (shared with the add-teacher form).
 */
export function TeacherInstituteFilter({
  value,
  onChange,
}: TeacherInstituteFilterProps) {
  const { t } = useTranslation(["teachers", "common"]);
  const { data, isLoading, isError } = useInstitutionOptions();

  return (
    <InstituteFilterSelect
      value={value}
      onChange={onChange}
      options={data}
      isLoading={isLoading}
      isError={isError}
      labels={{
        ariaLabel: t("teachers:activeFilter.institute"),
        all: t("teachers:filter.allInstitutes"),
        placeholder: t("teachers:filter.placeholder.institute"),
        loading: t("teachers:addForm.institution.loading"),
        loadFailed: t("teachers:addForm.institution.loadFailed"),
        searchPlaceholder: t("common:actions.search"),
        viewAll: t("common:actions.viewAll"),
      }}
    />
  );
}
